import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase'
import './registerServiceWorker'

Vue.config.productionTip = false
let app = '';
const config = { 
  apiKey: "AIzaSyDm8pgkk9VyKW8TdJNO46t1NfCgPlPzAls",
  authDomain: "suy-connect.firebaseapp.com",
  databaseURL: "https://suy-connect.firebaseio.com",
  projectId: "suy-connect",
  storageBucket: "suy-connect.appspot.com",
  messagingSenderId: "218088559254",
  appId: "1:218088559254:web:17bc7c43f437febb"
}
firebase.initializeApp(config);
firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')}
})
